import React, { useEffect, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextEditor = ({ value, setValue, quillRef, handleEditorChange, handleSelectionChange, inputError, ...props }) => {
  let { customDropDown } = props;

  useEffect(() => {
    if (!customDropDown?.active) return
    if (!customDropDown?.options?.length) return;


    const timeout = setTimeout(() => {
      const container = quillRef.current?.editor?.container?.parentNode;
      const toolbar = container?.querySelector('.ql-toolbar');
      if (!toolbar || toolbar.querySelector('.custom-dropdown-wrapper')) return;

      // === Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-dropdown-wrapper';

      //////////////////////// start
      if (props?.showIcon) {
        wrapper.style.width = '45px';
      }
      // === Create selected box (default view)
      const selected = document.createElement('div');
      selected.className = 'custom-dropdown-selected';
      //////////////////////// start
      if (props?.showIcon) {
        // Render the icon inside wrapper div
        selected.innerHTML = `<div class='d-flex'><i class='bi bi-info-circle-fill fs-16 validate-color'></i></div>`;
      } else {
        // Fallback text
        //////////////////////// end
        selected.textContent = 'Add Patient Info';
        //////////////////////// start
      }
      //////////////////////// end
      wrapper.appendChild(selected);

      // === Create options container
      const optionsContainer = document.createElement('div');
      optionsContainer.className = 'custom-dropdown-options';

      // === Populate options
      customDropDown.options.forEach(opt => {
        const option = document.createElement('div');
        option.className = 'custom-dropdown-option d-flex justify-content-between align-items-center gap-15';
        option.dataset.value = opt.value;

        // Create label (left side)
        const labelSpan = document.createElement('span');
        labelSpan.textContent = opt.display;
        labelSpan.className = 'text-dark'; // optional for styling

        // Create value/token (right side)
        const valueSpan = document.createElement('span');
        valueSpan.textContent = opt.value;
        valueSpan.className = 'color-95';

        // Append spans to the option div
        option.appendChild(labelSpan);
        option.appendChild(valueSpan);

        // On click: insert into Quill
        option.addEventListener('click', () => {
          const tag = option.dataset.value;
          if (!tag) return;

          const editor = quillRef.current?.getEditor();
          const range = editor?.getSelection(true);
          if (range) {
            editor.insertText(range.index, tag, {
              // italic: true,
              // color: 'gray',
              // size: '12px'
            });
            editor.setSelection(range.index + tag.length);
          }

          optionsContainer.classList.remove('show');
        });

        optionsContainer.appendChild(option);
      });


      // Append options to wrapper
      wrapper.appendChild(optionsContainer);

      // Toggle dropdown open/close
      selected.addEventListener('click', () => {
        optionsContainer.classList.toggle('show');
      });

      // Close dropdown on outside click
      document.addEventListener('click', function handleOutsideClick(e) {
        if (!wrapper.contains(e.target)) {
          optionsContainer.classList.remove('show');
        }
      });

      // Append to Quill toolbar
      toolbar.appendChild(wrapper);
    }, 0);

    return () => clearTimeout(timeout);
  }, [customDropDown, quillRef]);

  const textColors = [
    '#000000',
    'var(--orange)',
    'var(--orangeBright)',
    'var(--primary)',
    'var(--BlueColor)',
    'var(--BlueLight)',
  ];

  const backgroundColors = [
    'rgba(var(--orange-rgb), 0.07)',
    'rgba(var(--orangeBright-rgb), 0.07)',
    'rgba(var(--primary-rgb), 0.07)',
    'rgba(var(--BlueColor-rgb), 0.07)',
    'rgba(var(--BlueLight-rgb), 0.07)',
  ];


  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"],
      [{ font: [] }],
      // [{ size: ["small", false, "large", "huge"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ...(props?.isOpenedFrom === 'Form Builder' ? [[{ align: [] }]] : []),
      [{ 'color': textColors }, { 'background': backgroundColors }],
    ],
  };

  const formats = [
    "bold",
    "italic",
    "underline",
    "font",
    "size",
    "list",
    ...(props?.isOpenedFrom === 'Form Builder' ? ["align"] : []),
    'color',
    'background',
  ];

  // const handleCursorChange = () => {
  //   const editor = quillRef.current.getEditor();
  //   const position = editor.getSelection()?.index;
  //   if (position !== null && position !== undefined) {
  //     setCursorPosition(position);
  //   }
  //   console.log("position", position, cursorPosition)
  // };

  const placeholderMap = customDropDown?.options?.reduce((acc, curr) => {
    acc[curr.display] = curr.value
    return acc;
  }, {});

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      if (props?.placeholderReplacement !== true) return;
      if (!(customDropDown?.options?.length > 0)) return;

      const editor = quillRef.current?.getEditor();
      if (!editor) return;

      const range = editor.getSelection(true);
      if (!range || range.index === 0) return;

      const textBeforeCursor = editor.getText(0, range.index);
      const words = textBeforeCursor.trim().split(/\s+/);
      const lastTypedWord = words[words.length - 1];

      const replacement = placeholderMap[lastTypedWord];
      if (replacement) {
        const startIndex = textBeforeCursor.lastIndexOf(lastTypedWord);
        const endIndex = range.index;

        e.preventDefault();

        // Save current formatting
        const currentFormat = editor.getFormat(endIndex);

        // Replace word with formatted content
        editor.deleteText(startIndex, endIndex - startIndex);
        editor.insertText(startIndex, replacement + ' ', currentFormat);

        // Move cursor to end of inserted word
        setTimeout(() => {
          editor.setSelection(startIndex + replacement.length + 1);
        }, 0);

        // Update React state if needed — avoid `getText()` as it strips format
        // Better to use `getContents()` or `getHTML()` if you want to preserve style
        const updatedHtml = editor.root.innerHTML;
        setValue(updatedHtml);
      }
    }
  };



  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      value={value}
      style={inputError ? { border: `1px solid #FC171B` } : {}}
      onChange={(content) => {
        setValue(content);
      }}
      onKeyDown={handleKeyDown}
      modules={modules}
      formatOptions={formats}
      onChangeSelection={handleSelectionChange}
      placeholder={props?.placeholder || ''}
    // onKeyUp={handleEditorChange}
    />
  );
};

export default TextEditor;